import { Crisp } from "crisp-sdk-web";

let configured = false;
let currentProfile = null;

// Tags every authenticated student's chat session so support can segment
// "came from the T2 platform". Only set from the logged-in flow — the
// logged-out checkout never feeds a profile, so leads are not tagged.
const STUDENT_SEGMENT = "Aluno_T2";

// The website id comes from the support_profile payload — the backend reads
// it from the same Integration record that holds the REST API credentials.
export function configureCrisp(websiteId) {
  if (configured || !websiteId) return;

  Crisp.configure(websiteId);
  // Fires whenever a chatbox session finishes loading — on the initial load
  // and again after a session reset. This is the only moment the session is
  // safely readable, so all identification flows through it.
  Crisp.session.onLoaded(syncSessionWithProfile);
  configured = true;
}

// The Crisp session lives in long-lived cookies, so it survives the app's
// logout. Without a reset the next user on this browser would inherit the
// previous user's chat (history, contact, avatar). Called on sign out.
export function resetCrispSession() {
  // Forgotten before the reset so the onLoaded callback doesn't re-identify
  // the signed-out user on the fresh session.
  currentProfile = null;

  if (!Crisp.isCrispInjected()) return;

  Crisp.session.reset();
}

// Identifies the live chatbox session with the logged-in user. The rich
// support data (subscription, courses, progress…) is pushed to the contact
// from the backend via the Crisp REST API — the chatbox session:data path
// proved unreliable (timing + throttling + value rejection).
export function identifyCrispFromProfile(profile) {
  if (!profile) return;

  currentProfile = profile;

  // The chatbox swaps the $crisp stub for an object exposing get() once
  // loaded. Before that the session isn't readable — the onLoaded callback
  // registered in configureCrisp picks the profile up instead.
  if (typeof window.$crisp?.get !== "function") return;

  syncSessionWithProfile();
}

function syncSessionWithProfile() {
  if (!currentProfile) return;

  // Guards user switches that bypass the sign-out reset (e.g. expired
  // token): a persisted session identified as someone else is discarded. The
  // reset reloads the session, firing onLoaded again with a clean one.
  const sessionEmail = Crisp.user.getEmail();
  if (
    sessionEmail &&
    currentProfile.email &&
    sessionEmail !== currentProfile.email
  ) {
    Crisp.session.reset();
    return;
  }

  if (currentProfile.email) Crisp.user.setEmail(currentProfile.email);
  if (currentProfile.name) Crisp.user.setNickname(currentProfile.name);
  if (currentProfile.phone) Crisp.user.setPhone(currentProfile.phone);

  // Accumulative (overwrite=false): keeps any segments Crisp added on its side.
  Crisp.session.setSegments([STUDENT_SEGMENT], false);
}
